module.exports = __webpack_public_path__ + "60ad238dfd55c2440cf4eb13f7230af8.png";